module.exports = "/_next/static/images/kiv-2x-20450f3b09caf8a1c7c7203c3c6aebf9.jpg.webp";